import fetchIntercept from "fetch-intercept";
import AuthManager from "../Managers/Auth.manager";

fetchIntercept.register({
  response: function (response) {
    if (response.status === 401) {
      response?.clone()?.json()?.then((body) => {
        if (body?.error === "invalid_okta_token") {
          AuthManager.clearSession();
        }
      }).catch(() => {
        // ignore non-JSON or missing body
      });
    }
    return response;
  },

  responseError: function (error) {
    console.error("Response Error:", error);
    return Promise.reject(error);
  }
});